var map = {
	"./bg_color.svg": 1460,
	"./bright_contrast.svg": 1461,
	"./contrast.svg": 1462,
	"./cursorBlack.svg": 1463,
	"./cursorWhite.svg": 1464,
	"./dark_contrast.svg": 1465,
	"./focus_window.svg": 1466,
	"./fontSize.svg": 1467,
	"./height_saturation.svg": 1468,
	"./highlight_headers.svg": 1469,
	"./highlight_link.svg": 1470,
	"./low_saturation.svg": 1471,
	"./monochrome.svg": 1472,
	"./spacing.svg": 1473,
	"./text_color.svg": 1474,
	"./zoom.svg": 1475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 101;